module.exports = __webpack_public_path__ + "assets/img/melt_chocolate.18a1814c.png";